/* TDP - Notre histoire (sections tdp-histoire-*) : la photo de chaque
   bandeau defile doucement de gauche a droite (ou l'inverse) au scroll.
   Relance a chaque section rechargee dans l'editeur de theme. */
(function () {
  'use strict';
  if (window.tdpHistoireLoaded) return;
  window.tdpHistoireLoaded = true;

  var medias = [];
  function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }
  var ticking = false;

  function update() {
    var vh = window.innerHeight;
    medias.forEach(function (img) {
      var row = img.closest('.tdp-hist-row');
      if (!row) return;
      var rect = row.getBoundingClientRect();
      var center = rect.top + rect.height / 2;
      var progress = clamp((center - vh / 2) / (vh / 2 + rect.height / 2), -1, 1);
      var posLeft = 4, posRight = 96;
      var t = (1 - progress) / 2;
      var pos = img.classList.contains('tdp-hist-pan--reverse')
        ? posRight - t * (posRight - posLeft)
        : posLeft + t * (posRight - posLeft);
      img.style.objectPosition = pos + '% 50%';
    });
    ticking = false;
  }

  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }

  function collect() {
    medias = Array.prototype.slice.call(document.querySelectorAll('.tdp-hist-row-media img.tdp-hist-pan'));
    update();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collect);
  else collect();
  document.addEventListener('shopify:section:load', collect);
})();
